      <div class="modal-content">
        <div class="modal-header header">
          <h5 class="modal-title w-100" [translate]="Localization.EditChecklistType"></h5>
          <button type="button" class="close pull-right modal-close" aria-label="Close" (click)="close()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pt-0 lite-modal">
                <div class="mt-4">
                    <chapps-select-input
                      [placeholder]="Localization.ChecklistType | translate"
                      [items]="checklistTypeOptions"
                      [control]="checklistTypeField">
                    </chapps-select-input>
                </div>
              </div>
        <div class="modal-footer justify-content-end">
          <chapps-secondary-button 
              [loading]="isBusy"
              [label]="Localization.Save"
              [small]="true"
              (clicked)="onSubmit()">
          </chapps-secondary-button>
        </div>
      </div>